import { format } from 'date-fns';

/**
 * Calendar YYYY-MM-DD in the user's local timezone (not UTC).
 * Use for API date_interval / daily aggregates so picker dates match backend date keys.
 */
export function formatDateToLocalYYYYMMDD(d: Date): string {
  return format(d, 'yyyy-MM-dd');
}
